module.exports = __webpack_public_path__ + "static/media/Blokes-avatar-Evan-transparent.86a339d6.png";